var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"text-observe",rawName:"v-text-observe"}],staticClass:"intro"},[_c('div',{staticClass:"intro__content"},[_c('ClaimText',{attrs:{"canAnimate":_vm.isAnimated}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }